function initGallerySwipers(context) {
  context.querySelectorAll('[data-gallery-swiper]').forEach(function (el) {
    if (el.swiper) return;
    new Swiper(el, {
      slidesPerView: 1.15,
      spaceBetween: 22,
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      a11y: {
        enabled: true,
        containerMessage: el.getAttribute('aria-label') || 'Gallery',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
        slideLabelMessage: '{{index}} of {{slidesLength}}',
      },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initGallerySwipers(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initGallerySwipers(event.target);
});
